import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useCallback, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStudyL10nMap } from 'libs.localization.react';
import { LocaleStatusProgress, } from './locale_status_progress.component';
import { TranslationWorkbenchContext } from '../../contexts';
export const StudyLocaleStatusProgress = (props) => {
    const { studyId } = useParams();
    const { setStudyL10nMap } = useStudyL10nMap();
    const { study, updateStudy } = useContext(TranslationWorkbenchContext);
    // Use refs to avoid recreating handler when study object reference changes
    // Only recreate when the actual value we care about (l10nMapResourceId) changes
    const studyRef = useRef(study);
    const updateStudyRef = useRef(updateStudy);
    useEffect(() => {
        studyRef.current = study;
        updateStudyRef.current = updateStudy;
    }, [study, updateStudy]);
    const handler = useCallback((props) => {
        if (!studyId) {
            console.error(new Error('Internal error'));
            return;
        }
        const { id, locale, version } = props;
        // Use current value from study ref to avoid race condition
        // This ensures we always use the latest l10nMapResourceId even if study object reference changes
        const currentL10nMapId = studyRef.current.l10nMapResourceId;
        setStudyL10nMap({ studyId: parseInt(studyId, 10), currentL10nMapId, assetLocaleVersionSet: [{ id, locale, version }] }, {
            onSuccess: (response) => {
                if (response?.data?.id) {
                    studyRef.current.l10nMapResourceId = response.data.id;
                    updateStudyRef.current?.(studyRef.current);
                }
            },
            onError: (error) => {
                console.error('Failed to update study l10n map:', error);
                // Optionally show user notification here
            },
        });
    }, [studyId, setStudyL10nMap]);
    if (!studyId) {
        return null;
    }
    return _jsx(LocaleStatusProgress, { ...props, onStatusChange: handler });
};
